import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Colors } from '~/config/Colors';

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .padding-form {
    padding: 0 1em 1em 1em;
  }

  .row {
    margin-bottom: 0.5em;
  }

  .header {
    padding: 0 0.6rem;
    margin-bottom: 1rem;
    display: flex;

    .item-aba {
      border-radius: 0.5rem;
      padding: 0.3rem 0.8rem 0.3rem 0.5rem;
      background: ${Colors.Color2};
      margin-right: 0.6rem;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;

      span {
        content: '';
        display: block;
        width: 0.8rem;
        height: 0.8rem;
        background: ${Colors.Color4};
        margin-right: 0.5rem;
        margin-left: 0.2rem;
        border-radius: 0.15rem;
      }

      p {
        font-size: 0.8125rem;
        font-weight: 800;
        color: ${Colors.Color7};
      }
    }

    .item-aba.ativo {
      background: ${Colors.Color4} !important;

      span {
        background: ${Colors.Color9} !important;
      }

      p {
        color: ${Colors.Color9} !important;
      }
    }

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .item-modal {
    display: none;
  }

  .item-modal.ativo {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

export const CustomScrollBarCust = styled(CustomScrollBar)`
  overflow: hidden;
  // height: 23em !important;
`;
